import { handleActions } from 'redux-actions';
import moment from 'moment';
import 'moment-timezone';

import _cloneDeep from 'lodash/cloneDeep';
import _assign from 'lodash/assign';

import { getLogger } from '../../logger';

import { changeLocale, changeDisplayIntlForm } from './actions';

const logger = getLogger('intl');

const combine = (firstObj, secondObj) => {
  const obj = _cloneDeep(firstObj);
  return _assign(obj, secondObj);
};

const allowedLanguages = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'tr'];
const defaultLanguage = allowedLanguages[0];

function createIntlReducer({ locale, messages }) {
  logger.debug('Create reducer with: Locale', locale);
  const initialLanguage = allowedLanguages.find(entry => locale === entry) || defaultLanguage;
  const initialUrlPrefix = '/' + initialLanguage + '/';
  let initialMessages;
  if (initialLanguage === defaultLanguage) {
    initialMessages = messages.de;
  } else {
    initialMessages = {
      locales: messages[initialLanguage].locales,
      messages: combine(messages.de.messages, messages[initialLanguage].messages),
    };
  }

  const initialState = {
    mainLanguage: null,
    locale: initialLanguage,
    urlPrefix: initialUrlPrefix,
    messages: initialMessages,
    displayIntlForm: initialLanguage,
    allowedLanguages,
  };
  logger.debug('Initial state', { ...initialState, messages: {} });
  const changeLocaleReducer = (state = initialState, { payload: { locale } }) => {
    const strippedLocale = locale ? locale.substr(0, 2) : defaultLanguage;
    const lang = allowedLanguages.find(entry => strippedLocale === entry) || defaultLanguage;
    global.globalLocale = lang;

    moment.locale(lang);

    const result = {
      ...state,
      locale: lang,
      displayIntlForm: lang,
      urlPrefix: '/' + lang + '/',
      messages: {
        locales: messages[lang].locales,
        messages: combine(messages.en.messages, messages[lang].messages),
      },
    };
    logger.trace('Change: Locale', locale, 'State', state, 'NextState', result);
    return result;
  };

  const intlReducer = handleActions(
    {
      [changeLocale]: changeLocaleReducer,
      [changeDisplayIntlForm]: (state, { payload }) => ({ ...state, displayIntlForm: payload }),
    },
    initialState
  );
  return intlReducer;
}

export default createIntlReducer;

